import { TablePagination } from '@mui/material';
import React from 'react';

interface PaginationProps {
  handlePageChange: () => void;
  handleRowsPerPageChange: () => void;
  page: number;
  pageSize: number;
  totalCount: number;
}

const rowsPerPageOptions = [ 5, 10, 25, 50, 100 ];

const Pagination = React.memo(function Pagination({
  handlePageChange,
  handleRowsPerPageChange,
  page,
  pageSize,
  totalCount
}: PaginationProps) {
  return (
    <TablePagination
      component="div"
      count={totalCount}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      page={page}
      rowsPerPage={pageSize}
      rowsPerPageOptions={rowsPerPageOptions}
      SelectProps={{
        inputProps: { 'aria-label': 'rows per page' }
      }}
    />
  );
});

export default Pagination;
